import { render, staticRenderFns } from "./EconomicTab.vue?vue&type=template&id=2fb4fffc"
import script from "./EconomicTab.vue?vue&type=script&setup=true&lang=js"
export * from "./EconomicTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports